// extracted by mini-css-extract-plugin
export default {"bgColor":"clientSay_bgColor__pyGOW","clientSaytop":"clientSay_clientSaytop__iAPsM"};